<form [formGroup]="form" class="form" (ngSubmit)="onSubmit()" *ngIf="form">
  <div class="form-body">
    <div class="form-section">
      <app-form-row [label]="['FORMS.BRANCH.SFTP_SETTINGS.HOST', 'FORMS.BRANCH.SFTP_SETTINGS.PORT'] | translateControl : form | async">
        <div class="row">
          <div class="col-8">
            <app-input [type]="'text'" [mainForm]="form" [controlName]="'host'">
            </app-input>
          </div>
          <div class="col-4">
            <app-input [type]="'text'" [mainForm]="form" [controlName]="'port'">
            </app-input>
          </div>
        </div>
      </app-form-row>
      <app-form-row [label]="['FORMS.BRANCH.SFTP_SETTINGS.REMOTE_PATH'] | translateControl : form | async">
        <div class="row">
          <div class="col-8">
            <app-input [type]="'text'" [mainForm]="form" [controlName]="'remotePath'" [prefix]="'/'">
            </app-input>
          </div>
        </div>
      </app-form-row>

      <app-form-row [label]="'FORMS.BRANCH.SFTP_SETTINGS.USERNAME' | translateControl : form | async">
        <div class="row">
          <div class="col-12">
            <app-input [type]="'text'" [mainForm]="form" [controlName]="'username'">
            </app-input>
          </div>
        </div>
      </app-form-row>

      <app-form-row [label]="'FORMS.BRANCH.SFTP_SETTINGS.PASSWORD' | translateControl : form | async">
        <div class="row">
          <div class="col-12">
            <app-input-password [mainForm]="form" [controlName]="'password'" [layoutMod]="['password']" [showCondition]="true">
            </app-input-password>
          </div>
        </div>
      </app-form-row>

      <app-form-row *ngIf="isDealerSuperAdmin" [label]="''">
        <app-checkbox [mainForm]="form" [controlName]="'applyForAllBranches2'" [labelKey]="'title'"
          [options]="[{ isChecked: form.value.applyForAllBranches2, title: 'FORMS.BRANCH.SFTP_SETTINGS.USE_FOR_ORGANIZATION' }]"
          [layoutMod]="['box']">
        </app-checkbox>
      </app-form-row>

      <app-form-row [label]="''" class="reset-btn-row">
        <div class="row">
          <div class="col-auto">
            <button type="button" class="btn btn_sm btn_primary" (click)="validateConnection()" [disabled]="!canValidate">{{
                'FORMS.BRANCH.SFTP_SETTINGS.BTN_VALIDATE' | translate }}</button>
          </div>
          <div class="col col-validate-message" *ngIf="validateMessage">
            <ng-container *ngIf="validateMessageClass === 'valid'; else checkConnectionInvalid;">
              <span class="sftp-info-message sftp-info-message_valid">
                <i svgIcon [icon]="'checkbox-check'"></i>
                {{ ('SFTP_VALIDATION.' + validateMessage)| translate}}
              </span>
            </ng-container>
            <ng-template #checkConnectionInvalid>
              <span class="sftp-info-message sftp-info-message_invalid">
                <i svgIcon [icon]="'close_circle'"></i>
                {{ ('SFTP_VALIDATION.' + validateMessage)| translate}}
              </span>
            </ng-template>

          </div>
        </div>
      </app-form-row>
    </div>

  </div>

</form>
